<template>
<div class="block">
  <el-timeline v-if="lang=='zh'">
    <el-timeline-item
      v-for="(activity, index) in activitiesZh"
      :key="index"
      :icon="activity.icon"
      :type="activity.type"
      :color="activity.color"
      :size="activity.size"
      :timestamp="activity.timestamp">
      {{activity.content}}
    </el-timeline-item>
  </el-timeline>
  <el-timeline  v-if="lang=='en'">
    <el-timeline-item
      v-for="(activity, index) in activitiesEn"
      :key="index"
      :icon="activity.icon"
      :type="activity.type"
      :color="activity.color"
      :size="activity.size"
      :timestamp="activity.timestamp">
      {{activity.content}}
    </el-timeline-item>
  </el-timeline>
</div>
</template>

<script>
import mixin from "@/mixins"
export default {
  props:['themeColorParam','isOpenParm','previewPage'],
  data() {
    return {
      tablelist:[],
      activitiesZh:[],
      activitiesEn:[],
    };
  },
  mixins:[mixin],
  mounted(){
    if(this.previewPage){
      this.getListCrConference();
    }else{
      if(this.isOpenParm){
        this.getListCrConference();
      }
    }
  },
  methods:{
    /**
     * 请求列表
     * */
    getListCrConference(){
      let data = {
        pageNo:1,
        pageSize:1000,
        meetingCode:this.$route.params.meetingCode
      }
      this.$api.getListCrConference(data).then(res=>{
        if(res.code == 200){
          this.tablelist = res.data.data;
          this.handleData();
        }
      })
    },
    handleData(){
      let that = this;
      this.tablelist.some((data,i)=>{
        let objZh = {}
        objZh.content = data.title;
        objZh.timestamp = data.startTime+(data.endTime?"  -  "+data.endTime:'');
        let objEn = {}
        objEn.content = data.titleEn;
        objEn.timestamp = data.startTime+(data.endTime?"  -  "+data.endTime:'');
        if(i == 0){
          objZh.size = 'large',
          objZh.type =  'primary'
          objZh.color =  that.themeColorParam
          objEn.size = 'large',
          objEn.type =  'primary'
          objEn.color =  that.themeColorParam
        }
        this.activitiesZh.push(objZh);
        this.activitiesEn.push(objEn);
      })
    }
  }

}
</script>

<style scoped>

</style>
